module.exports = __webpack_public_path__ + "img/Telegram Icon.a96ef5e0.svg";